export const fieldIds = {
  street: "street",
  number: "number",
  postcode: "postcode",
  city: "city",
};
